import React from 'react'
import {Container, Row, Col} from 'react-bootstrap'
import Judul from './judul'
import './style.css'

export default function cards() {
    return (
        <div className="berberkah-cards">
            <Container>
            <Judul judul="Keunggulan Berberkah" />
            <Row>
                {
                    CardsBerberkah.map((item, i) => {
                        return (
                            <Col sm={6} key={i}>
                            <div className="card">
                                <img src={item.src} alt="card" />
                                <div className="card-body">
                                    <h5>{item.title}</h5>
                                    <p>{item.text}</p>
                                </div>
                            </div>
                        </Col>
                        )
                    })
                }
            </Row>
        </Container>
        </div>
    )
}

const CardsBerberkah = [
    {src:"asset/berberkah/card.svg", title:"100% Produk Halal", text:"Produk di Berikhtiar wajib mengantongi sertifikat halal dari Lembaga MUI untuk menjamin 100% kehalalan tiap produknya, karena bagi kami keamanan dan kenyamanan konsumen adalah yang utama."},
    {src:"asset/berberkah/card.svg", title:"Harga Lebih Murah", text:"Berikhtiar memberikan harga terbaik dari setiap produk yang dijual. Setiap produknya kami pilih dan verifikasi yang memiliki harga lebih murah langsung dari produsennya."},
    {src:"asset/berberkah/card.svg", title:"Mendukung Produk Lokal", text:"Berikhtiar berkomitmen memajukan ekonomi umat dengan mendukung pelaku UKM & UMKM lokal serta brand/produk halal untuk merambah bisnis digital."},
    {src:"asset/berberkah/card.svg", title:"Toko Online Mudah & Amanah", text:"Dalam memberikan pengalaman berbelanja yang menarik, kamu tidak perlu download aplikasi ataupun membuat akun untuk bertransaksi. Cukup 5x klik."}
]
